import { AcceptHealthClaimModalProps } from './types'
import { Button, Content, StyledModal } from './styles'
import AcceptHealthClaimModalHook from './AcceptHealthClaimModal.hook'
import message from '@/libs/message'
import { useQueryClient } from '@tanstack/react-query'

function AcceptHealthClaimModal({
  isModalOpen,
  claimFormId,
  claimNumber,
  insuredPersonName,
  onClose,
  mode = 'default',
}: AcceptHealthClaimModalProps) {
  const { useAcceptTaskByClaimFormId, redirectToHealthClaimDetailPage } =
    AcceptHealthClaimModalHook()
  const mutation = useAcceptTaskByClaimFormId(claimFormId)
  const queryClient = useQueryClient()

  const handleSuccess = () => {
    // Ensure detail is fresh when navigating
    queryClient.invalidateQueries({ queryKey: ['useGetClaimDetail', claimFormId] })
    onClose?.()
    redirectToHealthClaimDetailPage(claimFormId)
  }

  const handleError = () => {
    message.error('ไม่สามารถรับเคสได้ กรุณาลองใหม่อีกครั้ง')
  }

  const handleViewOnly = () => {
    onClose?.()
    redirectToHealthClaimDetailPage(claimFormId)
  }

  // Confirmation mode (from AcceptClaimButton)
  if (mode === 'confirmation') {
    return (
      <StyledModal
        open={isModalOpen}
        closable={false}
        width={350}
        centered
        onCancel={onClose}
        title="ยืนยันการรับเคส"
        footer={[
          <Button key="cancel" onClick={onClose}>
            ยกเลิก
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() =>
              mutation.mutate(undefined, { onSuccess: handleSuccess, onError: handleError })
            }
          >
            ยืนยัน
          </Button>,
        ]}
      >
        <Content>
          คุณต้องการดำเนินการพิจารณาการเคลม
          <br />
          เลขเคลม: {claimNumber || 'N/A'}
          <br />
          ผู้เอาประกัน: {insuredPersonName || 'N/A'}
        </Content>
      </StyledModal>
    )
  }

  // Default mode (from other components)
  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      centered
      title="ยืนยันรับหน้าที่เป็นผู้ดำเนินการพิจารณาเคลมในรายการนี้"
      width={350}
      footer={[
        <Button
          key="accept"
          onClick={() =>
            mutation.mutate(undefined, { onSuccess: handleSuccess, onError: handleError })
          }
        >
          รับเคส
        </Button>,
        <Button key="view" type="primary" onClick={handleViewOnly}>
          ดูอย่างเดียว
        </Button>,
      ]}
    >
      <Content>
        เลขเคลม: {claimNumber || 'N/A'}
        <br />
        ผู้เอาประกัน: {insuredPersonName || 'N/A'}
      </Content>
    </StyledModal>
  )
}

export default AcceptHealthClaimModal
